
export const getBSCExplorerUrl = () => {
  // Check if environment variable is set
  const explorerUrl = process.env.REACT_APP_BSC_EXPLORER_URL;
  
  if (explorerUrl) {
    // Ensure it ends with /tx/ for transaction URLs
    return explorerUrl.endsWith('/tx/') ? explorerUrl : `${explorerUrl}/tx/`;
  }
  
  // Default to testnet if no env variable is set
  return 'https://testnet.bscscan.com/tx/';
};

export const getBSCTxUrl = (txHash) => {
  if (!txHash) return '#';
  const baseUrl = getBSCExplorerUrl();
  return `${baseUrl}${txHash}`;
};

/**
 * Get blockchain explorer URLs for different chains
 * @param {string} chain - Chain identifier (BNB, ETH, SOL)
 * @returns {string} Explorer base URL for transactions
 */
export const getExplorerTxBase = (chain) => {
  const chainUpper = chain?.toUpperCase();
  
  switch (chainUpper) {
    case 'BNB':
      return getBSCExplorerUrl();
    case 'ETH':
      return 'https://etherscan.io/tx/';
    case 'SOL':
      return 'https://solscan.io/tx/';
    default:
      return getBSCExplorerUrl(); // Default to BSC
  }
};

/**
 * Get transaction URL for any chain
 * @param {string} chain - Chain identifier (BNB, ETH, SOL)
 * @param {string} txHash - Transaction hash
 * @returns {string} Full transaction URL
 */
export const getTxUrl = (chain, txHash) => {
  if (!txHash) return '#';
  const baseUrl = getExplorerTxBase(chain);
  return `${baseUrl}${txHash}`;
};
